import React, { Component } from 'react';
import styled from 'styled-components';

import theme from '../../styles/theme';
import Message from './Message.styled';

const MessageStyle = styled(Message)`
  box-shadow: 0px 3px 4px rgba(239, 83, 80, 0.2);
  i {
    color: ${theme.colors.danger};
  }
`;

type Props = {
  text: string;
  title?: string;
};

class ErrorMessage extends Component<Props> {
  render() {
    return (
      <MessageStyle>
        <div>
          <i className="material-icons">error</i>
        </div>
        <div>
          <b>{this.props.title || 'Error'}</b>
          <p>{this.props.text}</p>
        </div>
      </MessageStyle>
    );
  }
}

export default ErrorMessage;
